export default __webpack_public_path__ + "static/media/gear.7a1b768a.svg";